(function (global) {
  var assets = global.__fpSwiperAssets || {};
  var cssHref = assets.css || null;
  var jsSrc = assets.js || null;
  var RealSwiper = null;
  var loadPromise = null;
  var pendingInits = [];
  var flushing = false;

  function loadCss(href) {
    if (!href || document.querySelector('link[data-fp-swiper-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-fp-swiper-css', '1');
    document.head.appendChild(link);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (global.Swiper && global.Swiper.__fpIsStub !== true) {
        resolve(global.Swiper);
        return;
      }

      var existing = document.querySelector('script[data-fp-swiper-js]');
      if (existing) {
        existing.addEventListener('load', function () {
          resolve(global.Swiper);
        });
        existing.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-fp-swiper-js', '1');
      script.onload = function () {
        resolve(global.Swiper);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ensureSwiper() {
    if (RealSwiper) return Promise.resolve(RealSwiper);
    if (loadPromise) return loadPromise;

    loadPromise = new Promise(function (resolve, reject) {
      if (!jsSrc && global.__fpSwiperAssets) {
        cssHref = global.__fpSwiperAssets.css || cssHref;
        jsSrc = global.__fpSwiperAssets.js || jsSrc;
      }
      if (!jsSrc) {
        reject(new Error('fp-when-swiper: missing script src'));
        return;
      }

      loadCss(cssHref);
      loadScript(jsSrc)
        .then(function (SwiperCtor) {
          if (!SwiperCtor || SwiperCtor.__fpIsStub === true) {
            reject(new Error('fp-when-swiper: Swiper failed to load'));
            return;
          }
          RealSwiper = SwiperCtor;
          global.Swiper = SwiperCtor;
          document.dispatchEvent(new Event('fp:swiper-ready'));
          resolve(RealSwiper);
          flushPendingInits();
        })
        .catch(reject);
    });

    return loadPromise;
  }

  function resolveParams(params) {
    if (!params || !params.thumbs || !params.thumbs.swiper) return params;
    var thumb = params.thumbs.swiper;
    if (!thumb || !thumb.__fpDeferred) return params;

    var thumbEl = thumb.__fpEl;
    var realThumb =
      thumbEl && thumbEl.swiper && !thumbEl.swiper.__fpDeferred
        ? thumbEl.swiper
        : null;

    var next = {};
    for (var key in params) {
      if (Object.prototype.hasOwnProperty.call(params, key)) next[key] = params[key];
    }
    next.thumbs = {};
    for (var tKey in params.thumbs) {
      if (Object.prototype.hasOwnProperty.call(params.thumbs, tKey)) {
        next.thumbs[tKey] = params.thumbs[tKey];
      }
    }
    next.thumbs.swiper = realThumb;
    return next;
  }

  function flushPendingInits() {
    if (!RealSwiper || flushing) return;
    flushing = true;

    while (pendingInits.length) {
      var queue = pendingInits.splice(0, pendingInits.length);
      queue.forEach(function (entry) {
        if (!entry || !entry.el) return;
        if (entry.el.swiper && !entry.el.swiper.__fpDeferred) {
          entry.real = entry.el.swiper;
          entry.flushQueue();
          return;
        }
        try {
          entry.real = new RealSwiper(entry.el, resolveParams(entry.params));
          entry.flushQueue();
        } catch (err) {
          entry.el.dataset.fpSwiperPending = '';
        }
      });
    }

    flushing = false;
    if (pendingInits.length) flushPendingInits();
  }

  function createDeferredInstance(el, params) {
    if (!el) return null;

    if (el.swiper && !el.swiper.__fpDeferred) {
      return el.swiper;
    }
    if (el.swiper && el.swiper.__fpDeferred) {
      return el.swiper;
    }

    var callQueue = [];
    var entry = {
      el: el,
      params: params,
      real: null,
      flushQueue: function () {
        callQueue.forEach(function (item) {
          if (!entry.real) return;
          var value = entry.real[item.prop];
          if (typeof value === 'function') {
            value.apply(entry.real, item.args);
          }
        });
        callQueue = [];
      },
    };

    var proxy = new Proxy(
      {},
      {
        get: function (_target, prop) {
          if (prop === '__fpDeferred') return true;
          if (prop === '__fpEl') return el;
          if (entry.real) {
            var live = entry.real[prop];
            return typeof live === 'function' ? live.bind(entry.real) : live;
          }
          if (prop === 'then') return undefined;
          return function () {
            var args = Array.prototype.slice.call(arguments);
            callQueue.push({ prop: prop, args: args });
            return proxy;
          };
        },
        set: function (_target, prop, value) {
          if (entry.real) entry.real[prop] = value;
          return true;
        },
      }
    );

    entry.proxy = proxy;
    el.swiper = proxy;
    el.dataset.fpSwiperPending = '1';
    pendingInits.push(entry);

    ensureSwiper()
      .then(function () {
        flushPendingInits();
        el.dataset.fpSwiperPending = '';
      })
      .catch(function () {
        el.dataset.fpSwiperPending = '';
      });

    return proxy;
  }

  function SwiperStub(el, params) {
    if (RealSwiper) {
      return new RealSwiper(el, resolveParams(params));
    }
    return createDeferredInstance(el, params);
  }
  SwiperStub.__fpIsStub = true;
  global.Swiper = SwiperStub;

  global.fpWhenSwiper = function (callback) {
    if (typeof callback !== 'function') return;
    ensureSwiper()
      .then(function (SwiperCtor) {
        callback(SwiperCtor);
      })
      .catch(function () {});
  };

  global.fpConfigureSwiperLoader = function (config) {
    if (!config) return;
    if (config.css) cssHref = config.css;
    if (config.js) jsSrc = config.js;
  };

  global.fpLoadSwiper = ensureSwiper;

  function pageNeedsSwiper() {
    return Boolean(
      document.querySelector(
        '.swiper, .swiper-wrapper, .slideshow__swiper, .js-media-list, .js-media-sublist, .js-popup-slider, [class*="swiper--"]'
      )
    );
  }

  function boot() {
    if (!jsSrc && global.__fpSwiperAssets) {
      cssHref = global.__fpSwiperAssets.css || cssHref;
      jsSrc = global.__fpSwiperAssets.js || jsSrc;
    }
    if (!pageNeedsSwiper()) return;

    // Always start loading early when any swiper markup exists to reduce races.
    ensureSwiper();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(window);
